// see for details:
// https://vue-crud.github.io/guide/crud/field-options.html
export default {
  computed: {
    fieldsInfo () {
      return [
        {
          text: this.$t('fields.id'),
          name: 'id',
          details: false,
          table: false,
        },
        /* @add customers model and change to select field */
        {
          type: 'input',
          column: 'customer_id',
          text: this.$t('fields.customer_id'),
          grid: 'mt-3 xs12 sm6 md4 lg6 xl4',
          name: 'customer_id',
          multiedit: false,
          required: true,
          details: true,
          edit: false,
        },
        {
          type: 'input',
          column: 'url',
          text: this.$t('fields.url'),
          grid: 'mt-3 xs12 sm6 md4 lg6 xl4',
          name: 'url',
          multiedit: false,
          required: true,
        },
        {
          type: 'date',
          column: 'created',
          text: this.$t('fields.created'),
          grid: 'mt-3 xs12 sm6 md4 lg6 xl4',
          name: 'created',
          multiedit: false,
          edit: false,
          create: false,
        },
        // {
        //   column: 'updated',
        //   text: this.$t('fields.updated'),
        //   grid: 'xs12 sm6 md4 lg6 xl4',
        //   name: 'updated',
        //   multiedit: false,
        // },
        // {
        //   column: 'status',
        //   text: this.$t('fields.status'),
        //   grid: 'xs12 sm6 md4 lg6 xl4',
        //   name: 'status',
        //   multiedit: false,
        // },
        {
          type: 'date',
          column: 'check_last',
          text: this.$t('fields.check_last'),
          grid: 'mt-3 xs12 sm6 md4 lg6 xl4',
          name: 'check_last',
          multiedit: false,
          edit: false,
          create: false,
        },
        {
          type: 'select_with_options',
          column: 'check_interval_value',
          text: this.$t('fields.check_interval_value'),
          grid: 'mt-3 xs12 sm6 md4 lg6 xl4',
          name: 'check_interval_value',
          multiedit: false,
          options: {
            1440: '7 Tage',
          },
        },
        // {
        //   column: 'job_last',
        //   text: this.$t('fields.job_last'),
        //   grid: 'xs12 sm6 md4 lg6 xl4',
        //   name: 'job_last',
        //   multiedit: false,
        // },
        {
          type: 'checkbox',
          column: 'check_optimization',
          text: this.$t('fields.check_optimization'),
          grid: 'xs12 sm6 md4 lg6 xl4',
          name: 'check_optimization',
          multiedit: false,
          table: false,
        },
        {
          type: 'checkbox',
          column: 'check_screenshot',
          text: this.$t('fields.check_screenshot'),
          grid: 'xs12 sm6 md4 lg6 xl4',
          name: 'check_screenshot',
          multiedit: false,
          table: false,
        },
        {
          type: 'checkbox',
          column: 'check_countwords',
          text: this.$t('fields.check_countwords'),
          grid: 'xs12 sm6 md4 lg6 xl4',
          name: 'check_countwords',
          multiedit: false,
          table: false,
        },
      ]
    },
  },
}
